import classNames from "classnames";
import { motion } from "framer-motion";
import React from "react";
import { framerMotionAnimation } from "utils/animation";
import styles from "./styles.module.scss";

interface Props {
  className?: string;
  description?: string;
  icon?: string;
  image?: string;
  imageClassName?: string;
  subtitle?: string;
  title: string;
}

const Card: React.FC<Props> = ({
  className,
  description,
  icon,
  image,
  imageClassName,
  subtitle,
  title,
}) => {
  return (
    <motion.div
      className={classNames(styles.item, className)}
      {...framerMotionAnimation}
    >
      {image && (
        <div
          className={classNames(styles.image, imageClassName)}
          style={{ backgroundImage: `url(${image})` }}
        />
      )}

      {icon && (
        <div className={styles.iconContainer}>
          <div
            className={styles.icon}
            style={{ backgroundImage: `url(${icon})` }}
          />
        </div>
      )}

      <div className={styles.details}>
        <motion.h3 className={styles.name}>{title}</motion.h3>

        {subtitle && <motion.h3 className={styles.role}>{subtitle}</motion.h3>}

        <motion.p className={styles.description}>{description}</motion.p>
      </div>
    </motion.div>
  );
};

export default Card;
